import React, { useEffect, useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';

const BorderLinearProgress = withStyles((theme) => ({
    root: {
        height: 10,
        borderRadius: 19,
        background: '#D5E2EB',
        boxShadow: 'inset 0px 2px 2px rgba(0, 0, 0, 0.12)',
        zIndex: 1
    },
    colorPrimary: {
        backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
    },
    bar: {
        height: 10,
        borderRadius: 19,
        backgroundColor: '#1a90ff',
        zIndex: 0
    },
}))(LinearProgress);

const useStyles = makeStyles({
    root: {
        overflow: 'hidden',
        width: 210,
    },
});

export const ProgressBar = ({ setIsStopProgress }) => {
    const classes = useStyles();
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => {
            setProgress((oldProgress) => {
                if (oldProgress === 100) {
                    clearInterval(timer);
                    return oldProgress;
                }
                const diff = Math.random() * 25;

                return Math.min(oldProgress + diff, 100);
            });
        }, 500);
        if (progress === 100) {
            setIsStopProgress(true);
        }

        return () => {
            clearInterval(timer);
        };
    }, [progress, setIsStopProgress]);

    return (
        <div className={classes.root}>
            <BorderLinearProgress variant="determinate" value={progress} />
        </div>
    );
};
